import React from 'react'
import styles from '../Proj1Folder/Proj1.module.css'
import home from '../../Images/bayt elwatan.jpeg'






export default function BaytElwatan() {
  return (

    <>
        <div className="container my-5 py-5 ">
          <div className="row  align-items-center">
            <div className="col-md-6">
                <h3 className={`${styles.color} my-3`}> Bayt Al Watan Building  ​</h3>
                {/* <p> Project description: Design </p>
                <p>Type of contract: Design and supervision </p>
                <p>Type of works : Architectural, Civil and Electromechanical </p> */}
            </div>
            <div className="col-md-6">
                <img src={home} alt="achegy" className='img-fluid'/>
            </div>   

          </div>

        </div>

    </>
  )
}
